var React = require('react');

function IcPresentOn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M21 6C22.6569 6 24 4.65685 24 3C24 1.34315 22.6569 0 21 0C19.3431 0 18 1.34315 18 3C18 4.65685 19.3431 6 21 6ZM5 2H16.1C16.0344 2.32311 16 2.65753 16 3C16 3.34247 16.0344 3.67689 16.1 4H5C3.89543 4 3 4.89543 3 6V14C3 15.1046 3.89543 16 5 16H19C20.1046 16 21 15.1046 21 14V8C21.7111 8 22.3875 7.85155 23 7.58396V14C23 16.2091 21.2091 18 19 18H13V20H16V22H8V20H11V18H5C2.79086 18 1 16.2091 1 14V6C1 3.79086 2.79086 2 5 2Z"}));
}

IcPresentOn.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = IcPresentOn;

IcPresentOn.default = IcPresentOn;
